import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
    mutation sourceAttributionMutation($input: SourceAttributionInput!) {
        sourceAttribution(input: $input) {
            message
        }
    }
`;

export function sourceAttributionMutation(environment, args) {
    const {
        guestUserId,
        landingPage,
        type,
        userId,
        userToken,
        emailToken,
        visitCount,
        pageVisits,
        onCompleted,
        onError,
    } = args;
    commitMutation(environment, {
        mutation,
        variables: {
            input: {
                guestUserId,
                landingPage,
                type,
                userId,
                userToken,
                emailToken,
                visitCount,
                pageVisits,
            },
        },
        onCompleted,
        onError,
    });
}
